import styled from 'styled-components';

export const Container = styled.div`
  /* max-width: 1440px; */
  padding: 20px;
`;

export const Notice = styled.div`
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    text-align: center;

    h2 {
      font-size: 2.8rem/* 36px */;
       line-height: 2.5rem/* 40px */;
       margin-bottom: 12px;
       font-family: 'Inter', sans-serif;
    }

    h1 {
      font-size: 1.20rem/* 20px */;
      line-height: 1.75rem/* 28px */;
       font-family: 'Inter', sans-serif;

    }

    a {
      color: #4c83ee;

      &:hover {
        color: #566583;
      }
    }
  }
`;

export const DataUR = styled.div`
  h1 {
    font-family: 'Inter';
    /* font-size: 36px; */
    font-weight: 500;
    margin-bottom: 10px;
  }

  p {
    font-family: 'Inter';
  }
`;


export const ReceiverData = styled.div`
  margin-top: 30px;
  /* border: 1px solid #D3D3D3; */
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 8px;
  background: #fff;
`;


export const Form = styled.form`
  legend {
    font-family: 'Inter';
    font-size: 20px;
    margin-bottom: 20px;
  }

  .check-box {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
      color: #333;
    }
    .MuiFormControlLabel-root {
      margin-right: 0;
    }
    .css-ahj2mt-MuiTypography-root {
      font-family: 'Inter';
      font-weight: 500;
      color: #333;
      font-size: 15px;

    }

  }
  .input-group {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .input-group.tripple {
    display: flex;
    flex-direction: column;

    @media(min-width: 600px) {
      flex-direction: row;
    }
  }

  .input-wrapper {
    width: 100%;
    .input {
        background: #fff;
        width: 100%;
    }

  }
  .hook-error {
    color: #f7345b;
    font-family: 'Inter';
    font-size: 14px;
  }
  
  .text-area {
    width: 100%;
    outline: none;
    min-height: 80px;
    border: 1px solid #D3D3D3;
    border-radius: 6px;
    padding: 6px;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    color: #333;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
  }
`;


export const UnidadesRecebiveis = styled.div`
  width: 100%;
  margin-top: 60px;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 8px;
  background: #fff;

  h2 {
    margin-bottom: 20px;
    font-family: 'Inter';
    font-weight: 500;
  }
`;
// export const Table = styled.table`
//   width: 100%;
//   text-align: left;
// `;

export const Table = styled.table`
  padding: 10px;
  table-layout: fixed;
  /* border: 1px solid #333; */
  border-collapse: collapse;
  width: 100%;

  thead {
    padding: 0 10px;
    border-bottom: 1px solid #D3D3D3;

    th {
      color: #a8a39d;
      font-weight: 400;
      font-family: 'Poppins';
      font-size: 14px;
      padding: 10px 0;
    }

    th:first-child {
      /* width: 50px; */
      padding: 0 10px;
    }

    th:last-child {
      /* width: 10%; */
    }
  }

  tbody {

    tr:not(tr:last-child) {
      border-bottom: 1px solid #D3D3D3;
    }

    tr > td {
      color: #333;
      font-family: 'Inter';
      font-weight: 400;
      font-size: 14px;
    }

    td:first-child {
      /* width: 50px; */
      padding: 0 10px;
    }
    tr {
      cursor: pointer;

      &:hover {
        background: rgba(0, 157, 221, 0.1);
      }
    }
  }

  td, th {
    padding: 15px 0;
    text-align: left;
  }
`;


export const ConfirmModal = styled.form`
  height: calc(75vh - 60px);
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  .title {
    /* border-bottom: 1px solid #D3D3D3; */
    /* padding-bottom: 10px; */
    display: flex;
    align-items: center;
    gap: 8px;

    h3 {
      font-family: 'Inter';
      font-weight: 500;
      font-size: 20;
      color: #ff6600;
    }
  }
  .content {
    height: 100%;
    margin: 20px 0;
    padding: 10px 0;
    border-bottom: 1px solid #D3D3D3;
    border-top: 1px solid #D3D3D3;
    display: flex;
    flex-direction: column;
    p {
      font-size: 17px;
      font-family: 'Inter';
    }
    span {
      font-weight: 600;
      /* font-size: 16px; */
    }
  }
  p {
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: space-between; */
    margin: auto 0;

  }
  .actions {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
  }
`;
